import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, isRef as _isRef, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "delivery" }
const _hoisted_2 = { class: "selectTitle" }
const _hoisted_3 = {
  key: 0,
  class: "selectTitle"
}
const _hoisted_4 = { class: "boxCard" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "trips"
}
const _hoisted_8 = { class: "content" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "Distance" }
const _hoisted_14 = {
  key: 1,
  class: "trips"
}
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { style: {"margin":"15px 0"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { reactive, ref, onMounted, watch, toRefs } from 'vue'
import { Get, Post } from '@/utils/api'
import { ElMessageBox, FormInstance, FormRules } from 'element-plus'
import { useI18n } from 'vue-i18n'
import AddressCard from '@/components/user-center/address_card.vue'
import moment from 'moment'
import getDistance from '@/utils/distance'
import Password from '../password.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'delivery',
  props: {
  Date: Object,
  ShowDelivery: Boolean,
},
  emits: ["DeliveryChange"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const checkList = ref([])
const IsFlashDelivery = ref(false)
const emit = __emit

const DoneDelivery = () => {
  emit('DeliveryChange', false)
}

const WarehouseList = ref([])
const setCustomerAddress = (Warehouses) => {
  CustomerAddress.value = Warehouses
  switch (DictionaryId.value) {
    case 1:
      CheckIsDeliveryRange()
      break
    case 2:
      GetBoxFreight()
      break
  }
}

const SetWarehouse = (val) => {
  showRepository.value = false
}

const DictionaryChagne = () => {
  if (RepositoryType.value == 1) {
    ExpectFreight()
  }
}

const showRepository = ref(false)
const RepositoryType = ref(0)
const WarehouseId = ref(null)
const Amount = ref(null)
const ExpectFreight = (id) => {
  Amount.value = null
  WarehouseId.value = id
  const BoxIds = checkList.value.map((item) => item.BoxId)
  const body =
    RepositoryType.value == 0
      ? {
        WarehouseId: id,
        BoxIds,
      }
      : {
        IsThirdParty: 'True',
        BoxIds,
      }
  Post('orders/api/DeliveryOrderExpectFreight/', body).then((res: any) => {
    Amount.value = res.Amount
  })
}

const DeliveryLoad = ref(false)
const SubmitPay = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      PayLoad.value = true
      Get('user/api/CustomerPwdIsLock/', { TypeId: 1 }).then(
        (res: any) => {
          PayLoad.value = false
          if (!res.IsError) {
            if (res.IsLock) {
              ElMessageBox.alert(
                t(`交易密码已锁定`, {
                  name: moment(res.LockTime).format('YYYY-MM-DD HH:mm:ss'),
                }),
                '',
                {
                  confirmButtonText: 'OK',
                  showClose: false,
                }
              )
            } else {
              SubmitDelivery()
            }
          }
        },
        () => { }
      )
    }
  })
}

const SubmitBox = () => {
  if ((totalFee.value > 0 || Amount.value > 0) && DictionaryId.value !== 5) {
    ShowPay.value = true
    Get('bank/api/CustomerBalance/', {
      CustomerId: 0,
    }).then((res: any) => {
      BalanceItem.value =
        res.BalanceItems.length > 0 ? res.BalanceItems[0] : null
    })
  } else {
    ShowPay.value = false
    SubmitDelivery()
  }
}

const SubmitDelivery = () => {
  let body
  if (RepositoryType.value == 1 && showRepository.value) {
    //第三方
    body = {
      AddressId: CustomerAddress.value.AddressId,
      BoxList: checkList.value,
      IsThirdParty: 'True',
      TypeId: DictionaryId.value,
      PayPwd: totalFee.value > 0 ? PayForm.pay_password : null,
      AllDeliveryFee: Amount.value || totalFee.value || null,
    }
  } else if (DictionaryId.value != 5) {
    body = {
      BoxList: checkList.value,
      TypeId: DictionaryId.value,
      AddressId: CustomerAddress.value.AddressId,
      PayPwd: totalFee.value > 0 ? PayForm.pay_password : null,
      AllDeliveryFee: Amount.value || totalFee.value || null,
      WarehouseId: WarehouseId.value,
      ToolId: tools.value[toolId.value].TranToolId,
    }
  } else {
    //自提
    body = {
      BoxList: checkList.value,
      ExpectStartTime: Timelist.value.StartHour,
      ExpectEndTime: Timelist.value.EndHour,
    }
  }
  Post('orders/api/DeliveryServerByNew/', body).then((res: any) => {
    ShowPay.value = false
    showRepository.value = false
    ElMessageBox.alert(t('提交成功'), '', {
      confirmButtonText: 'OK',
      showClose: false,
      closeOnPressEscape: false,
      callback: () => {
        emit('DeliveryChange', true)
      },
    })
  })
}

const CustomerAddress = ref(null)
const GetDefaultAddress = () => {
  Get('orders/api/GetPickUpExpectTime', {}).then((res: any) => {
    DateList.value = res.DateList
    Timelist.value = DateList.value[0].Timelist[0]
  })
  Get('basic/api/BasicDictionary/', {
    type_id: 96,
  }).then((res: any) => {
    DictionaryId.value = res.BasicDictionaryList[0].DicValue
    DictionaryList.value = res.BasicDictionaryList
    DictionaryChange(res.BasicDictionaryList[0].DicValue)
  })
  IsDeliveryRange.value = true
  Get('user/api/GetCustomerDefaultAddress', {}).then((res: any) => {
    CustomerAddress.value = res
    CheckIsDeliveryRange()
  })
}

const IsDeliveryRange = ref(true)
const CheckIsDeliveryRange = () => {
  const IsCheckPay = Date.value.find((item) => item.IsNeedCheckRange)
  if (IsCheckPay) {
    Post('basic/api/CheckIsDeliveryRange', {
      LatSize: CustomerAddress.value.LatSize,
      LngSize: CustomerAddress.value.LngSize,
      WarehouseId: IsCheckPay.WarehouseId,
    }).then((res: any) => {
      IsDeliveryRange.value = res.IsDeliveryRange
      if (res.IsDeliveryRange) {
        Amount.value = 0
      } else {
        showRepository.value = true
        WarehouseList.value = res.Warehouses || []
        if (!res.Warehouses) {
          RepositoryType.value = 1
          ExpectFreight()
        }
      }
    })
  }
}

const UserWarehousesList = ref(null)
const GetReceiveAddresses = () => {
  Get('user/api/ReceiveAddresses_New/', {
    addressTypeId: 1,
  }).then((res: any) => {
    UserWarehousesList.value = res.ReceiveAddresses
  })
}

const props = __props
const { Date, ShowDelivery } = toRefs(props)

const tools = ref([])
const toolId = ref(null)
watch(
  () => ShowDelivery.value,
  (val) => {
    IsFlashDelivery.value = Date.value.some(
      (item) => item.IsFlashDelivery === true
    )
    if (val) {
      GetDefaultAddress()
      Get('basic/api/ExpressTranTool', {}).then((res: any) => {
        tools.value = res.tools
        toolId.value = 0
      })

      if (totalFee.value > 0) {
        Get('basic/api/BasicDictionary', {
          type_id: 216,
          value_id: 10,
        }).then((res: any) => {
          DescTitle.value = res.BasicDictionaryList[0].DicName
          res.BasicDictionaryList.forEach((ele) => {
            DescContent.value += ele.Desc + '<br/>'
          })
        })
      }
    }
  }
)

const setFee = () => {
  totalFee.value = 0
  checkList.value.forEach((ele) => {
    totalFee.value += ele.DeliveryFee
  })
}

const DateTimeChange = (val) => {
  Timelist.value = DateList.value[val].Timelist[0]
}

const DonePay = () => {
  ShowPay.value = false
}

const DictionaryId = ref(null)
const DictionaryList = ref(null)
const DateList = ref(null)
const Timelist = ref(null)
const totalFee = ref(0)
const DescTitle = ref(null)
const DescContent = ref('')
const ShowPay = ref(false)
const PayLoad = ref(false)
const PayForm = reactive({
  pay_password: null,
})
const payRules = reactive<FormRules>({
  pay_password: [{ required: true, message: t('请输入'), trigger: 'blur' }],
})
const BalanceItem = ref(null)
const PayRef = ref<FormInstance>()
const WarehouseInfo = ref(null)
const checkboxChange = async (value) => {
  switch (DictionaryId.value) {
    case 2:
      if (value.length > 1) {
        checkList.value = [value[value.length - 1]]
      }
      if (!WarehouseInfo.value) {
        WarehouseInfo.value = await Get('basic/api/WarehouseInfo', {
          ware_id: Date.value[0].WarehouseId,
        }).then()
      }
      const Distance = getDistance(
        CustomerAddress.value.LatSize,
        CustomerAddress.value.LngSize,
        WarehouseInfo.value.LatSize,
        WarehouseInfo.value.LngSize
      )
      if (tools.value[toolId.value].DistanceLimit > Distance) {
        GetBoxFreight()
      } else {
        ElMessageBox.alert(t('超出配送范围'), 'Tips', {
          confirmButtonText: 'OK',
        })
        checkList.value = []
      }
      break
    default:
      break
  }
}

const isBusinessCity = ref(null)
const checkAddress = () => {
  Post('basic/api/CheckLocationInCity', {
    LatSize: CustomerAddress.value.LatSize,
    LngSize: CustomerAddress.value.LngSize,
    BusinessType: 2,
  }).then((res) => {
    isBusinessCity.value = res.BusinessCity == null
    if (!res.BusinessCity) {
      ElMessageBox.alert(t('超出配送范围'), 'Tips', {
        confirmButtonText: 'OK',
      })
    }
  })
}

const GetBoxFreight = () => {
  checkAddress()
  if (!checkList.value[0].NotFlashDeliveryReason) {
    Post('orders/api/FlashDeliveryBoxExpectFreight/', {
      ApiName: 'api/FlashDeliveryBoxExpectFreight/',
      BoxSerialNo: checkList.value[0].Serail,
      AddressId: CustomerAddress.value.AddressId,
    }).then((res: any) => {
      totalFee.value = res.freight
    })
  }
}

const DictionaryChange = (val) => {
  switch (val) {
    case 1:
    case 5:
      CheckAllBox(true)
      break
    default:
      CheckAllBox(false)
      break
  }
}

const CheckAllBox = (isAll) => {
  checkList.value = isAll ? Date.value : []
  setFee()
}

onMounted(() => { })

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Box = _resolveComponent("Box")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_PhoneFilled = _resolveComponent("PhoneFilled")!
  const _component_Location = _resolveComponent("Location")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      modelValue: _unref(ShowDelivery),
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(ShowDelivery) ? (ShowDelivery).value = $event : null)),
      title: _ctx.$t('发起配送'),
      width: "900px",
      top: "5vh",
      "before-close": DoneDelivery,
      center: true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            onClick: DoneDelivery,
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('关闭')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            size: "large",
            disabled: (!IsDeliveryRange.value && DictionaryId.value == 1) ||
          (!CustomerAddress.value && DictionaryId.value != 5 && !showRepository.value) ||
          (DictionaryId.value == 2 && isBusinessCity.value) ||
          checkList.value.length == 0
          ,
            loading: DeliveryLoad.value,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (SubmitBox()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('提交')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _createVNode(_component_el_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('配送方式')) + ":", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_group, {
              modelValue: DictionaryId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((DictionaryId).value = $event)),
              onChange: DictionaryChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(DictionaryList.value, (Dictionary) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: Dictionary.DicValue
                  }, [
                    (!(Dictionary.DicValue == 2 && !IsFlashDelivery.value))
                      ? (_openBlock(), _createBlock(_component_el_radio, {
                          key: 0,
                          label: Dictionary.DicValue
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(Dictionary.DicName), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (DictionaryId.value == 2)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _createVNode(_component_el_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('运输工具')) + ":", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio_group, {
                  modelValue: toolId.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((toolId).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tools.value, (tool, index) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: index,
                        label: index
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tool.TranTool), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (DictionaryId.value !== 5)
            ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                key: 1,
                "max-height": "200px",
                class: "UserWarehousesList"
              }, {
                default: _withCtx(() => [
                  (CustomerAddress.value && !UserWarehousesList.value)
                    ? (_openBlock(), _createBlock(AddressCard, {
                        key: 0,
                        item: CustomerAddress.value,
                        isDefault: true,
                        index: 0
                      }, null, 8, ["item"]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(UserWarehousesList.value, (Warehouses, index) => {
                    return (_openBlock(), _createBlock(AddressCard, {
                      item: Warehouses,
                      index: index,
                      isDefault: Warehouses.AddressId == CustomerAddress.value.AddressId,
                      key: index,
                      onClick: ($event: any) => (setCustomerAddress(Warehouses))
                    }, null, 8, ["item", "index", "isDefault", "onClick"]))
                  }), 128)),
                  (!UserWarehousesList.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "AddressesPlaceholder",
                        onClick: GetReceiveAddresses
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('显示全部')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (DictionaryId.value == 5)
            ? (_openBlock(), _createBlock(_component_el_tabs, {
                key: 2,
                type: "border-card",
                onTabChange: DateTimeChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(DateList.value, (DateTime, index) => {
                    return (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: index,
                      label: DateTime.Date
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: Timelist.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((Timelist).value = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(DateTime.Timelist, (Time) => {
                              return (_openBlock(), _createBlock(_component_el_radio, {
                                key: Time,
                                label: Time,
                                size: "large"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(Time.HoutTag), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_checkbox_group, {
            modelValue: checkList.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((checkList).value = $event)),
            onChange: checkboxChange
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Date), (item) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: item.Serail
                  }, [
                    _createVNode(_component_el_card, null, {
                      default: _withCtx(() => [
                        (
                DictionaryId.value === 1 ||
                (DictionaryId.value === 2 && item.IsFlashDelivery)
              )
                          ? (_openBlock(), _createBlock(_component_el_checkbox, {
                              disabled: false,
                              label: item,
                              key: item.Serail,
                              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                            }, {
                              default: _withCtx(() => []),
                              _: 2
                            }, 1032, ["label"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Box)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.Serail), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _hoisted_5,
                          _createVNode(_component_el_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.InStockStatus), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _hoisted_6,
                          (DictionaryId.value === 2 && item.NotFlashDeliveryReason)
                            ? (_openBlock(), _createBlock(_component_el_text, {
                                key: 0,
                                style: {"position":"absolute"},
                                type: "danger",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.NotFlashDeliveryReason), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (DictionaryId.value !== 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$t('配送费')) + "： ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(totalFee.value)), 1),
                (totalFee.value > 0)
                  ? (_openBlock(), _createBlock(_component_el_popover, {
                      key: 0,
                      placement: "top-start",
                      title: DescTitle.value,
                      width: 250,
                      trigger: "hover"
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_el_icon, { style: {"font-size":"24px","margin-left":"5px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_WarningFilled, { color: "#f1541e" })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", { innerHTML: DescContent.value }, null, 8, _hoisted_9)
                      ]),
                      _: 1
                    }, 8, ["title"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: ShowPay.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ShowPay).value = $event)),
      title: _ctx.$t('支付订单'),
      width: "400px",
      "before-close": DonePay,
      center: true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: DonePay,
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('关闭')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            size: "large",
            loading: PayLoad.value,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (SubmitPay(PayRef.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('支付')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "PayRef",
          ref: PayRef,
          model: PayForm,
          rules: payRules,
          "label-position": "top",
          class: "PackageForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('账户余额')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(BalanceItem.value
            ? BalanceItem.value.AvailableAmount + ' ' + BalanceItem.value.CurrencyCode
            : 0 + ' ' + _ctx.$SiteSet['CurrencyCode']) + " ", 1),
                _createVNode(_component_router_link, { to: { path: '/userCenter/wallet' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "RechargeBtn",
                      type: "danger",
                      onClick: DonePay
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('充值')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('应付金额')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$ccy(Amount.value || totalFee.value)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('交易密码'),
              prop: "pay_password"
            }, {
              default: _withCtx(() => [
                _createVNode(Password, {
                  modelValue: PayForm.pay_password,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((PayForm.pay_password) = $event)),
                  isShowSet: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      width: "600px",
      modelValue: showRepository.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((showRepository).value = $event)),
      title: _ctx.$t('配送站点')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: RepositoryType.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((RepositoryType).value = $event)),
          style: {"margin-bottom":"20px"},
          onChange: _cache[11] || (_cache[11] = ($event: any) => (DictionaryChagne()))
        }, {
          default: _withCtx(() => [
            (WarehouseList.value.length > 0)
              ? (_openBlock(), _createBlock(_component_el_radio_button, {
                  key: 0,
                  label: 0
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('更换站点')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_radio_button, { label: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('第三方配送')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (RepositoryType.value == 0)
          ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(WarehouseList.value, (Warehouse) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([
          'WarehouseCard',
          { SelectCard: Warehouse.WarehouseId == WarehouseId.value },
        ]),
                    onClick: ($event: any) => (ExpectFreight(Warehouse.WarehouseId))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["WarehouseName", WarehouseId.value])
                    }, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(Warehouse.WarehouseName) + " ", 1),
                        (Warehouse.IsSelf)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" (" + _toDisplayString(_ctx.$t('自营')) + ") ", 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(Warehouse.Address), 1),
                      _createElementVNode("p", null, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_PhoneFilled)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('电话咨询')), 1)
                      ])
                    ], 2),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_unref(getDistance)(
                  Warehouse.LatSize,
                  Warehouse.LngSize,
                  CustomerAddress.value.LatSize,
                  CustomerAddress.value.LngSize
                )) + " km ", 1),
                      _createVNode(_component_el_icon, { size: 30 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Location)
                        ]),
                        _: 1
                      })
                    ])
                  ], 10, _hoisted_12))
                }), 256))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (Amount.value > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.$t('费用')) + ": ", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$ccy(Amount.value)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_16, [
          _createTextVNode(" *" + _toDisplayString(_ctx.$t('配送网点为直营，属于转仓服务，会收转仓服务费')) + " ", 1),
          _hoisted_17,
          _createTextVNode(" *" + _toDisplayString(_ctx.$t('配送网点为代理，属于转单服务，转入乐达本土快递配送，会收快递运费')) + " ", 1),
          _hoisted_18,
          _createTextVNode(" *" + _toDisplayString(_ctx.$t('未可用网点，则系统默认发起为转第三方快递配送，会收一个转单服务费')) + " ", 1),
          _hoisted_19
        ]),
        _createVNode(_component_el_button, {
          disabled: (!WarehouseId.value && RepositoryType.value == 0) || Amount.value == null,
          style: {"width":"100%"},
          type: "danger",
          size: "large",
          loading: DeliveryLoad.value,
          onClick: _cache[12] || (_cache[12] = ($event: any) => (SubmitBox()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('提交')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})